import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './Common/ReduxStore/Store';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import common_en from "./locales/en/common.json";
import common_guj from "./locales/guj/common.json";
import common_tam from "./locales/tam/common.json";
import common_tri from "./locales/tri/common.json";
import common_miz from "./locales/miz/common.json";
const root = ReactDOM.createRoot(document.getElementById('root'));
i18next.init({
  interpolation: { escapeValue: false },
  lng: 'en',                             
  resources: {
    en: {
      common: common_en          
    },
    guj: {
      common: common_guj,
    },
    tam: {
      common: common_tam,
    },
    tri: {
      common: common_tri,
    },
    miz: {
      common: common_miz,
    },
  },
});
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
      <I18nextProvider i18n={i18next}>
        <App />
        </I18nextProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

reportWebVitals();
